import Promise from 'core-js/es6/promise';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch'
import $ from "cash-dom";

import { initModules } from './index';
import { gamEvent } from './animation';
import LayerLinkModule from './layerlink';
import { scrollToY, scrollToTop } from '../util/scrollTo';

/** 
 * @TODO test cancel polyfill 
 * https://www.npmjs.com/package/abortcontroller-polyfill
 */


let $body,
    $page,
    $mainNav,
    currLocation,
    isLoading = false;

const cache = [];

const controller = new AbortController();
const { signal } = controller;

export default class XhrModule {

    static name = 'xhr'

    constructor(node) {
    
        currLocation = window.location.pathname;
            
        $page = $('.page');
        $body = $('body');
        $mainNav = $('.block-header nav');

        $body.on('click', 'a[href^="/"]', handleSiteLink);

        window.addEventListener('popstate', () => {
            loadAjax(window.location.pathname, false);
        }, false);

        //make sure all other modules are loaded before we initially trigger deepanchors
        $(window).one('modsloaded', () => {
            scrollToAnchor(window.location.href);
        });
    }
}


/**
 * handleSiteLink
 * Wechselt die Hauptseite via Ajax
 */
function handleSiteLink(e) {

    var $this = $(this),
        href = $this.attr('href'),
        url = href.split('#').shift();

    //deny muted links
    if($this.data('mutedlink')) return false;

    //allow explicit roundtrips
    if($this.data('roundtrip')) return true;

    //allow file access
    if(checkFtype(href)) return true;
    
    //allow external links
    if($this.attr('target') === '_blank') return true;

    //deny same location, scroll to anchor
    if(url === currLocation) {
        //scroll to possible anchor
        if(scrollToAnchor(href)) {
            window.history.replaceState(null, '', href);
        }

        return false;
    }

    if(isLoading) return false;

    e.preventDefault();

    //close layer
    LayerLinkModule.close();

    //fade-out page
    $page
        .one('transitionend', () => {
            
            loadAjax( href, true );
        })
        .addClass('hidden');
    
    //trigger gamLinkLoading
    gamEvent('gamLinkLoading');
}


/**
 * loadAjax
 */
function loadAjax( href, isPush ) {

    if(isLoading) {
        controller.abort();
    }
    isLoading = true;
 
    const url = href.split('#').shift();

    cacheFetch(url)
        .then(res => {

            isLoading = false;
            currLocation = url;

            //push to history
            if(isPush) {
                window.history.pushState(null, '', href);
            }

            //replace dom content
            const $newPage = $(res);
            $page
                .empty()
                .append( $newPage.children() )
                .attr('class', 'hidden ' + $newPage.attr('class'))

            //fade-in page with delay
            window.setTimeout(function() {
                $page.removeClass('hidden');
            }, 5000);

            //update body class
            const classes = $body.attr('class').split(' ')
                .filter(c => c.indexOf('page-') !== 0)
            
            classes.push('page-' + $newPage.data('id'))
            $body.attr('class', classes.join(' '))
            

            //init modules
            initModules($page);

            //scroll to anchor or to top
            if(!scrollToAnchor(href)) {
                scrollToTop();
            }

            //trigger new animation
            gamEvent('gamLinkLoaded');
        })
}


/**
 * cacheFetch
 */
function cacheFetch(url) {
    
    return new Promise(function(resolve, reject) {
        if(cache[url]) {
            console.log('serving', url, 'from cache');
            //add artificial delay for spread animation
            window.setTimeout(() => {
                resolve(cache[url]);
            }, 500);
        } else {
            console.log('fetching', url, '...');
            resolve(
                //@TODO error handling
                window.fetch(url, {
                    headers: {
                        "X-Requested-With": "XMLHttpRequest"
                    },
                    signal: signal
                })
                .then(res => res.text())
                .then(res => {
                    cache[url] = res;
                    return res;
                })
            )
        }
    })
}


/**
 * scrollToAnchor
 * handle deep anchorlinks like #kalender, #kalender/basf-sommerkonzert
 */
function scrollToAnchor(url) {
    
    const parts = url.split('#');
    if(parts.length < 2) return false;
        
    const subparts = parts[1].split('/');
    let $targetBlock = $(`#${subparts[0]}`);
    if(!$targetBlock.length) return false;

    let blockY = $targetBlock.offset().top;
    let targetY = blockY;

    if(subparts.length > 1) {
        const $targetSub = $(`#${subparts[1]}`);
        if($targetSub.length) {
            $targetSub.trigger('deepanchor');
            const subY = $targetSub.offset().top;
            if(subY > blockY + window.innerHeight/2) {
                targetY = subY - (window.innerHeight/4);
            }
        }
    }

    scrollToY(targetY)
    return true;
}


/**
 * checkFtype
 */
function checkFtype(url) {

    const ftypes = ['jpg', 'jpeg', 'gif', 'png', 'pdf', 'mp3'];
    const ext = url.split('.').pop();

    return ftypes.indexOf(ext) !== -1;
}